import React, { useEffect, useRef, useState } from 'react';

export default function FeatureCarousel() {
  const features = [
    { icon: '💪', title: 'برنامه‌سازی هوشمند', desc: 'برنامه تمرین و تغذیه با هوش مصنوعی' },
    { icon: '⏱️', title: 'تحویل فوری', desc: 'برنامه کامل در کمتر از ۳ ساعت' },
    { icon: '🏠', title: 'تمرین در خانه', desc: 'برنامه‌هایی متناسب با تمرین در خانه، حتی بدون ابزار و فقط با وزن بدن' },
    { icon: '🎯', title: 'کاملاً شخصی‌سازی‌شده', desc: 'برنامه مخصوص سطح و شرایط شما' },
    { icon: '📥', title: 'دانلود و استفاده آفلاین', desc: 'برنامه تمرین + ویدئوها با یک بار دانلود، همیشه در دسترس حتی بدون اینترنت'
    }
  ];

  const scrollRef = useRef(null);
  // const [index, setIndex] = useState(0);

  

  

  return (
    <section className="bg-white dark:bg-[#1a1d2e] py-16 px-6">
      <div className="max-w-6xl mx-auto text-center mb-10">
        <h3 className="text-2xl font-bold mb-4">چرا موجیم؟</h3>
        <p className="text-gray-600 dark:text-gray-300">
          برخی از ویژگی‌های اصلی پلتفرم هوشمند موجیم را ببینید:
        </p>
      </div>

      <div ref={scrollRef} className="overflow-x-auto scroll-smooth -mx-4 md:mx-0 px-4">
        <div className="flex gap-4 w-fit sm:w-max">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="min-w-[260px] h-52 sm:min-w-[260px] sm:h-52 bg-gray-100 dark:bg-[#2a2f3b] p-6 rounded-xl shadow text-center flex flex-col justify-center items-center space-y-2"
            >
              <div className="text-3xl mb-3">{item.icon}</div>
              <h4 className="text-lg font-bold mb-1">{item.title}</h4>
              <p className="text-sm text-gray-700 dark:text-gray-300">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
